export const PTQ = 
{
    Metadata:{Name:'PTQ',maxColumn:5,numRows:15},
    Sections:
    [
        {
            Headers:[
                "In this questionnaire, you will be asked to describe how you typically think about negative experiences or problems.",
                "Never",
                "Rarely",
                "Sometimes",
                "Often",
                "Almost Always"
            ],
            Questions:[
                {
                    Prompt:"1. The same thoughts keep going through my mind again and again.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"2. Thoughts intrude into my mind.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"3. I can't stop dwelling on them.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"4. I think about many problems without solving any of them.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"5. I can’t do anything else while thinking about my problems.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"6. My thoughts repeat themselves.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"7. Thoughts come to my mind without me wanting them to.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"8. I get stuck on certain issues and can't move on.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"9. I keep asking myself questions without finding an answer.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"10. My thoughts prevent me from focusing on other things.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"11. I keep thinking about the same issue all the time. ",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"12. Thoughts just pop into my mind.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"13. I feel driven to continue dwelling on the same issue.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"14. My thoughts are not much help to me.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"15. My thoughts take up all my attention.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
            ]
        }
    ]
}